module.exports = __webpack_public_path__ + "media/components/assets/soccer_image_01-d5045ef78d4302a2bf4c1d6756cc6b40.jpg";